import { createAsyncThunk } from '@reduxjs/toolkit';

import { AuthService } from '../../services';

export const signIn = createAsyncThunk('authSlice/signIn', async (data, { rejectWithValue }) => {
  try {
    const response = await AuthService.signIn(data);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to sign in.');
  }
});

export const signUp = createAsyncThunk('authSlice/signUp', async (data, { rejectWithValue }) => {
  try {
    const response = await AuthService.signUp(data);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to sign up.');
  }
});

export const savePhone = createAsyncThunk('authSlice/savePhone', async (data, { rejectWithValue }) => {
  try {
    const response = await AuthService.savePhone(data);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to save phone.');
  }
});

export const verifyEmail = createAsyncThunk('authSlice/verifyEmail', async (data, { rejectWithValue }) => {
  try {
    await AuthService.verifyEmail(data);
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to verify email.');
  }
});

export const verifyPhone = createAsyncThunk('authSlice/verifyPhone', async (data, { rejectWithValue }) => {
  try {
    await AuthService.verifyPhone(data);
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to verify phone.');
  }
});

export const resendEmailCode = createAsyncThunk('authSlice/resendEmailCode', async (data, { rejectWithValue }) => {
  try {
    const response = await AuthService.resendEmailCode(data);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to resend email OTP.');
  }
});
